module.exports = __webpack_public_path__ + "img/landingEpc.c57876fd.svg";